export default __webpack_public_path__ + "static/media/CounterRightImage.03292752.png";